var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg.id)?_c('svg',{class:( _obj = {}, _obj[_vm.$style.icon] = true, _obj[_vm.$style._inline] = this.inline, _obj )},[_c('use',{attrs:{"xlink:href":("#" + (_vm.svg.id))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }